import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/use-auth";

const NavbarButton = ({ page, text }) => {
  return (
    <button className={page === 1 ? "btn btn-primary" : "btn btn-light"}>
      {text}
    </button>
  );
};

const Navbar = () => {
  const [page, setPage] = useState(1);
  const auth = useAuth();

  const handlePageChange = (page) => {
    setPage(page);
    sessionStorage.setItem("page", page);
  };

  return (
    <div className="min-vh-100 position-relative w-100 m-1 shadow border p-3">
      <div className="d-flex flex-column">
        <Link
          onClick={() => handlePageChange(1)}
          to="/organizations"
          className="ml-auto mb-4 col-auto col-md-5"
        >
          <NavbarButton page={page} text="Организации" />
        </Link>
        <Link
          onClick={() => {
            handlePageChange(1);
            auth.signout();
          }}
          to="/signin"
          className="ml-auto mb-4 col-auto col-md-5"
          style={{ marginTop: "30vw" }}
        >
          <button className="btn btn-secondary">Выйти</button>
        </Link>
      </div>
    </div>
  );
};

export default Navbar;

{
  /*<Link*/
}
{
  /*  onClick={handlePageChange(2)}*/
}
{
  /*  to="/salaries"*/
}
{
  /*  className="ml-auto mb-4 col-auto col-md-auto"*/
}
{
  /*>*/
}
{
  /*  <button className={page === 2 ? "btn btn-primary" : "btn btn-light"}>*/
}
{
  /*    Зар. платы*/
}
{
  /*  </button>*/
}
{
  /*</Link>*/
}
{
  /*<Link*/
}
{
  /*  onClick={handlePageChange(3)}*/
}
{
  /*  to="/phonebooks"*/
}
{
  /*  className="ml-auto mb-4 col-auto col-md-5"*/
}
{
  /*>*/
}
{
  /*  <button className={page === 3 ? "btn btn-primary" : "btn btn-light"}>*/
}
{
  /*    Справочники*/
}
{
  /*  </button>*/
}
{
  /*</Link>*/
}
